export default function Footer() {
  return (
    <footer className="bg-black py-10 sm:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center justify-center gap-5 sm:gap-6 mb-6 sm:mb-8">
          <img
            alt="Four Models"
            className="h-14 sm:h-20 object-contain"
            src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/f6ba88513f846dcaf1ba402d9a75d603.png"
            loading="lazy"
            decoding="async"
          />
          <div className="text-center">
            <p className="text-white font-bold text-base sm:text-lg mb-1">Seletiva Presencial Four Models</p>
            <p className="text-gray-400 text-sm">19 de Abril de 2026 &mdash; Domingo</p>
            <p className="text-gray-400 text-sm">14h ou 16h</p>
            <p className="text-gray-400 text-sm">Jandaia Hotel</p>
            <p className="text-gray-400 text-sm">Campo Grande &ndash; MS</p>
          </div>
          <div className="flex items-center gap-5 text-gray-400">
            <a
              href="https://www.instagram.com/fourmodelsoficial/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://www.facebook.com/fourmodelsoficial"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-circle-line text-xl"></i>
            </a>
            <a
              href="https://wa.me/5566998977297?text=Ol%C3%A1!%20Tenho%20d%C3%BAvidas%20sobre%20a%20Seletiva%20Four%20Models%20em%20Campo%20Grande%20-%20MS%20(19%2F04%20no%20Jandaia%20Hotel)%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es!"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="hover:text-yellow-500 transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 text-center">
          <p className="text-gray-500 text-xs">
            &copy; 2026 Four Models. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
